import Vue from 'vue';
import VueLodash from 'vue-lodash';

/**
 * For tree-shaking, list all needed functions
 */
import get from 'lodash/get';
import orderBy from 'lodash/orderBy';
import cloneDeep from 'lodash/cloneDeep';
import debounce from 'lodash/debounce';
import isEqual from 'lodash/isEqual';
import keyBy from 'lodash/keyBy';
import camelCase from 'lodash/camelCase';
import omit from 'lodash/omit';
import intersection from 'lodash/intersection';
import chunk from 'lodash/chunk';

Vue.use(VueLodash, {
	lodash: {
		get,
		orderBy,
		cloneDeep,
		debounce,
		isEqual,
		keyBy,
		camelCase,
		omit,
		intersection,
		chunk,
	},
});
